import React from 'react'
import Spinner from '../spinner/Spinner'
import './Loader.less'

/**
 * @deprecated
 * Use instead <Spinner/> from front-end/src/components
 */
const Loader = () => {
  return (
    <div className="Loader">
      <Spinner />
    </div>
  )
}

export default Loader
